import { Injectable, inject } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { QuoteType } from "../CNP/services/product-facade";

export interface GlobalState {
  custNum: number;
  shipToNum: string;
  orderNum: number;
  company: string;
  partNum: string;
  lang?: string;
  version?: string;
  useLossFactor: boolean;
  quoteType?: QuoteType;
  quoteId?: number;
  quoteLineId?: number;
}

let state: GlobalState = {
  custNum: 0,
  shipToNum: "",
  orderNum: 0,
  company: "",
  partNum: "",
  lang: null,
  version: "",
  useLossFactor: false,
  quoteType: null,
  quoteId: null,
  quoteLineId: null,
};

@Injectable({
  providedIn: "root",
})
export class GlobalStateService {
  private authSvc = inject(AuthenticationService);

  private store = new BehaviorSubject<GlobalState>(state);
  private state$ = this.store.asObservable();

  public get isAuthenticated(): boolean {
    return this.authSvc.isAuthenticated;
  }

  public get userName(): string {
    return this.authSvc.userName;
  }

  public get langNameID(): string {
    return this.store.value.lang ?? this.authSvc.langNameID;
  }

  public get appReady(): boolean {
    return this.isAuthenticated;
  }

  public get custNum(): number {
    return this.store.value.custNum;
  }

  public get shipToNum(): string {
    return this.store.value.shipToNum;
  }

  public get tokenType(): string {
    return this.authSvc.tokenType;
  }

  public get orderNum(): number {
    return this.store.value.orderNum;
  }

  public get partNum(): string {
    return this.store.value.partNum;
  }

  public get company(): string {
    return this.store.value.company;
  }

  public get version(): string {
    return this.store.value.version;
  }

  public get useLossFactor(): boolean {
    return this.store.value.useLossFactor;
  }

  public get quoteType(): QuoteType {
    return this.store.value.quoteType;
  }

  public get quoteId(): number {
    return this.store.value.quoteId;
  }

  public get quoteLineId(): number {
    return this.store.value.quoteLineId;
  }

  public get isQuoteLineEditing(): boolean {
    return (
      this.quoteType !== null &&
      this.quoteId !== null &&
      this.quoteLineId !== null
    );
  }

  public updateQueryParams(newState: GlobalState) {
    this.store.next((state = newState));
  }

  public isQueryStringValid(): boolean {
    const isInvalid =
      this.store.value.custNum === 0 ||
      this.store.value.custNum === undefined ||
      this.store.value.shipToNum === undefined ||
      this.store.value.company === "" ||
      this.store.value.company === undefined;

    return !isInvalid;
  }
}
